import React, {Fragment, useState} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from "react-i18next";
import {Button, Card, Form} from "antd";
import Selector from "../../selector";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import EnhancedModal from "../../enhanced-modal";
import {MODAL_WIDTH_LG, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS} from "../../../styles/constants";
import Call from "../../../hocs/call";
import ArtefactList from "../../artefact-list";
import {readELDstDataflows, setELDstDataflow, unsetELDstDataflow} from "../actions";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  dstDataflow: state.scenes.easyLoading.dstDataflow,
  dstDataflows: state.scenes.easyLoading.dstDataflows
});

const mapDispatchToProps = dispatch => ({
  fetchDataflows: () => dispatch(readELDstDataflows()),
  onDataflowSet: dataflow => dispatch(setELDstDataflow(dataflow)),
  onDataflowUnset: () => dispatch(unsetELDstDataflow())
});

const formItemLayout = {
  labelCol: {span: SPAN_ONE_QUARTER},
  wrapperCol: {span: SPAN_THREE_QUARTERS}
};

const ELDataSelect = ({
                        t,
                        appLanguage,
                        dataLanguages,
                        dstDataflow,
                        dstDataflows,
                        fetchDataflows,
                        onDataflowSet,
                        onDataflowUnset
                      }) => {

  const [isVisible, setVisibility] = useState(false);

  return (
    <Fragment>
      <Card type="inner">
        <Form className="advanced-form">
          <Form.Item
            className="form-item-required"
            label={t('components.easyLoading.steps.data.body.dataSelect.label')}
            {...formItemLayout}
          >
            <Selector
              value={dstDataflow}
              render={dataflow => dataflow
                ? getLocalizedStr(dataflow.name, appLanguage, dataLanguages)
                : ""
              }
              selectTitle={t('components.easyLoading.steps.data.body.dataSelect.select')}
              resetTitle={t('components.easyLoading.steps.data.body.dataSelect.reset')}
              onSelect={() => setVisibility(true)}
              onReset={onDataflowUnset}
            />
          </Form.Item>
        </Form>
      </Card>
      <EnhancedModal
        visible={isVisible}
        onCancel={() => setVisibility(false)}
        title={t('components.easyLoading.steps.data.body.dataSelect.modals.dataflow.title')}
        width={MODAL_WIDTH_LG}
        footer={
          <Button onClick={() => setVisibility(false)}>
            {t('commons.buttons.close.title')}
          </Button>
        }
      >
        <Call
          cb={fetchDataflows}
          disabled={!isVisible}
        >
          <ArtefactList
            artefacts={dstDataflows || []}
            onRowClick={dataflow => {
              onDataflowSet(dataflow);
              setVisibility(false);
            }}
            getIsDisabledRow={dataflow => !dataflow.isFinal}
          />
        </Call>
      </EnhancedModal>
    </Fragment>
  )
};


export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(ELDataSelect);



// WEBPACK FOOTER //
// ./src/components/easy-loading/data-step/DataSelect.jsx